import gsap from 'gsap';

function show(textContainer, container) {
  container.classList.add('accordion-is-open');
  const tl = gsap.timeline();
  tl.set(textContainer, {
    height: 'auto',	
    visibility: 'visible'
  })
  .from(textContainer, {
    height: 0,
    duration: 0.2,
    ease: 'power2.out',
    immediateRender: false
  });
}

function hide(textContainer, container) {
  container.classList.remove('accordion-is-open');
  gsap.to(textContainer, {
    height: 0,
    duration: 0.1,
    ease: 'none',	
  });
}

function toggle(button) {
  const container = button.closest(".js-accordion-container");
  const textContainer = container.querySelector(".js-accordion-text-container");
  if (container.classList.contains('accordion-is-open')) {
    hide(textContainer, container);
  } else {
    show(textContainer, container);
  } 
}

export default function() {
  document.addEventListener("click", function(e) {
    const clicked = e.target;
    const button = clicked.closest('.js-accordion-button');
    if (button) {
      toggle(button);
    } 
  });
}